import React from 'react';
import { LANGUAGE_STORAGE_KEY, includedLanguages } from './languages';

const SCRIPT_ID = 'google-translate-script';

function setTranslateCookie(language) {
  const value = `/en/${language || 'en'}`;
  document.cookie = `googtrans=${value};path=/`;
  document.cookie = `googtrans=${value};domain=${window.location.hostname};path=/`;
}

function applyLanguage(language) {
  const selected = language || 'en';
  setTranslateCookie(selected);
  const combo = document.querySelector('.goog-te-combo');
  if (combo) {
    combo.value = selected;
    combo.dispatchEvent(new Event('change'));
  }
}

export default function GoogleTranslate() {
  React.useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (!window.google?.translate?.TranslateElement) return;
      new window.google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages,
        autoDisplay: false,
      }, 'google_translate_element');
      setTimeout(() => applyLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en'), 400);
    };

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google?.translate?.TranslateElement) {
      window.googleTranslateElementInit();
    }

    const onLanguage = (event) => applyLanguage(event.detail?.language || localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en');
    window.addEventListener('rozops-language-change', onLanguage);
    return () => window.removeEventListener('rozops-language-change', onLanguage);
  }, []);

  return <div id="google_translate_element" className="google-translate-shell" aria-hidden="true" />;
}
